import React from 'react';
import {OauthLoginProps} from "./OauthLoginPage";
import {Card, Flex, theme, Typography} from "antd";
import {useNavigate} from "react-router";
import {useLoginButton} from "./login-button/useLoginButton";
import {LoadingOverlay} from "../common/loading/component";
import {launcherCard} from "../common/styles";
import {LoginButton} from "./login-button/component";

export const OauthLoginButton: React.FC<OauthLoginProps> = (props) => {
    const {redirectLocation} = props;
    const {useToken} = theme;
    const {token} = useToken();
    const navigate = useNavigate();
    const targetLocation = redirectLocation ? redirectLocation : '/profile';
    const {
        working,
        setWorking,
        login,
        captureUser
    } = useLoginButton(() => navigate(targetLocation), targetLocation);

    return (
        <>
            <LoadingOverlay working={working} />
            <Flex justify={"center"} align={"center"}>
                <Card style={{backgroundColor: token.colorBgBase, padding: '5px', maxWidth: '400px', marginTop: '100px', ...launcherCard}}>
                    <Flex justify={"center"}>
                        <Typography.Title level={3}>Get ready to roll some dice!</Typography.Title>
                    </Flex>
                    <Flex justify={"center"} align={"center"} style={{padding: '3px'}}>
                        <LoginButton login={login} captureUser={captureUser} setWorking={setWorking}/>
                    </Flex>
                </Card>
            </Flex>
        </>
    )
}